import LocaleWrap from './wrapPageElement';
import imagesLoaded from 'imagesloaded';

export const onClientEntry = async () => {
  if (typeof window !== 'undefined') {
    try {
      const { initMapboxPolyfills } = await import('./src/utils/mapbox-polyfills');
      initMapboxPolyfills();
    } catch (e) {
      console.warn('[Gatsby] Erro ao carregar polyfills:', e.message);
    }
  }
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return false;
  return true;
};

export const wrapPageElement = LocaleWrap;
